export const getName = user =>
  user.fullName ? user.fullName : `${user.first_name} ${user.last_name}`;

export const prof = name => `Lect. ${name}`;

export const usernameText = user =>
  user.role === 'Teacher' ? prof(getName(user)) : getName(user);
export const usernameColor = user =>
  user.role === 'Teacher' ? 'primary' : 'textPrimary';
